// 设置闹钟——主流程
const MainRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `blacklist/index${i + 1}`,
  name: `blacklistIndex${i + 1}`,
  component: () => import(`@/views/use/blacklist/index${i + 1}.vue`)
}))



export default {
  path: '/use',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置闹钟——主流程，开始
    ...MainRoutes,

  ],
};
